import { useIntl } from "react-intl";
import { SkinProductKey } from "~/api/models/SkinProductKey";
import { useFetchProducts } from "~/api/salesForce/useFetchProducts";
import FillerProductCard from "~/components/organisms/Pricing/FillerProductCard/FillerProductCard";
import useDefaultProduct from "~/hooks/useDefaultProduct";

const CheeksFillerCard = () => {
  const intl = useIntl();
  const { data: allProducts, isLoading } = useFetchProducts();
  const defaultProduct = useDefaultProduct(allProducts.skin.filler.cheeks);

  return (
    <FillerProductCard
      skinProductFamilyKey={SkinProductKey.cheeksFiller}
      defaultProduct={defaultProduct}
      cardTitle={intl.formatMessage({
        id: "pricing.cheeksFiller",
      })}
      options={allProducts.skin.filler.cheeks}
      blankOptionTitle={intl.formatMessage({
        id: "treatment.pricing.cheeksFiller.none",
      })}
      modalTitle={intl.formatMessage({
        id: "pricing.cheeksFiller",
      })}
      isLoading={isLoading}
    />
  );
};

export default CheeksFillerCard;
